import { useEffect, useRef } from "react";

// Kablosuz barkod okuyucu / el terminali = klavye emülasyonu. Hızlı tuş dizisi + Enter yakalanır.
let _actx;
export function scannerBeep() {
  try {
    _actx = _actx || new (window.AudioContext || window.webkitAudioContext)();
    if (_actx.state === "suspended") _actx.resume();
    const o = _actx.createOscillator();
    const g = _actx.createGain();
    o.connect(g); g.connect(_actx.destination);
    o.type = "square"; o.frequency.value = 2000;
    g.gain.setValueAtTime(0.06, _actx.currentTime);
    o.start();
    g.gain.exponentialRampToValueAtTime(0.0001, _actx.currentTime + 0.08);
    o.stop(_actx.currentTime + 0.09);
  } catch { /* ses yoksa sessiz geç */ }
}

/**
 * Global barkod "wedge" yakalayıcı. Cihaz (okuyucu/el terminali) klavye gibi yazar;
 * bu hook imleç bir input'ta değilken hızlı diziyi tampona alıp Enter'da onScan çağırır.
 */
export default function useScannerWedge({ onScan, enabled = true, beep = true, minLen = 3 }) {
  const cb = useRef(onScan);
  cb.current = onScan;
  useEffect(() => {
    if (!enabled) return;
    let buf = "";
    let timer;
    const onKey = (e) => {
      const t = e.target;
      const tag = (t?.tagName || "").toLowerCase();
      if (tag === "input" || tag === "textarea" || tag === "select" || t?.isContentEditable) return;
      if (e.key === "Enter") {
        if (buf.length >= minLen) { if (beep) scannerBeep(); cb.current(buf); }
        buf = "";
        return;
      }
      if (e.key.length === 1) {
        buf += e.key;
        clearTimeout(timer);
        timer = setTimeout(() => { buf = ""; }, 120);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => { window.removeEventListener("keydown", onKey); clearTimeout(timer); };
  }, [enabled, beep, minLen]);
}
